import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import { axiosAPI, axiosupload } from "../../Components/AxiosComponents/Axios";

import {
  Grid,
  Typography,
  Paper,
  Button,
  Checkbox,
  TextField,
  Autocomplete,
  Avatar,
  Box,
  IconButton,
  Tabs,
  Tab,
  Backdrop,
  CircularProgress,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DeleteIcon from "@mui/icons-material/Delete";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

import { decryptId } from "../../Components/CryptoComponent";
import TextInput from "../../Components/InputComponents/TextInput";
import TextAreaInput from "../../Components/InputComponents/TextAreaInput";
import SelectInput from "../../Components/InputComponents/SelectInput";
import CommonButton from "../../Components/InputComponents/CommonButton";

const EditCandidate = () => {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));
  const location = useLocation();
  const navigate = useNavigate();

  const paginationState = location?.state?.pagination || {
    page: 0,
    rowsPerPage: 25,
  };

  const filterData = location?.state?.filterData;

  const expandedIds = location?.state?.expandedIds || "";
  const open = location?.state?.open || "";

  const [candidateData, setCandidateData] = useState({
    CI_Name: "",
    CI_Alias: "",
    CI_Dateofbirth: null,
    CI_PassportNo: "",
    CI_PrimaryEmail: "",
    CI_SecondaryEmail: "",
    CI_PrimaryMobile: "",
    CI_EmergencyMobile: "",
    CI_Address: "",

    CI_IsMedical: 0,
    CI_Profession: null,
    CI_Designation: "",
    CI_YearofExp: null,
    CI_Registration_License: "",
    CI_Registration_License_expry: "",
    CI_Department1: "",
    CI_Department2: "",
    CI_Department3: "",
    CI_Last_working_date: null,
    CI_CareerGap: 0,
    CI_CareerGapDetl: "",

    CI_CREmp: [],
    CI_DocOfficer: [],
    CI_Branch: null,
    CI_Status: null,
    CI_UserName: "",
  });

  const [isDisabled, setIsDisabled] = useState(false);
  const [loaderOpen, setLoaderOpen] = useState(false);

  const [initialData, setInitialData] = useState(null);

  const [isDisabledTab, setIsDisabledTab] = useState({
    tab0: true,
    tab1: true,
    tab2: true,
    tab3: true,
  });

  const tabFields = {
    tab0: [
      "CI_Photo",
      "CI_Name",
      "CI_Alias",
      "CI_Dateofbirth",
      "CI_PassportNo",
      "CI_PrimaryEmail",
      "CI_SecondaryEmail",
      "CI_PrimaryMobile",
      "CI_EmergencyMobile",
      "CI_Address",
    ],
    tab1: [
      "CI_IsMedical",
      "CI_Profession",
      "CI_Designation",
      "CI_YearofExp",
      "CI_Registration_License",
      "CI_Registration_License_expry",
      "CI_Department1",
      "CI_Department2",
      "CI_Department3",
      "CI_Last_working_date",
      "CI_CareerGap",
      "CI_CareerGapDetl",
    ],
    tab2: [
      "CI_CREmp",
      "CI_DocOfficer",
      "CI_Branch",
      "CI_Status",
      "CI_UserName",
    ],
  };

  const compareTabs = (newData) => {
    if (!initialData) return;

    const updatedDisabled = { ...isDisabledTab };

    Object.entries(tabFields).forEach(([tabKey, fields]) => {
      const hasChanged = fields.some((field) => {
        const newVal = newData[field] ?? null;
        const oldVal = initialData[field] ?? null;

        const normalize = (val) =>
          val?.toString()?.replace(/^\[|\]$/g, "") ?? "";

        if (["CI_CREmp", "CI_DocOfficer"].includes(field)) {
          return normalize(newVal) !== normalize(oldVal);
        }

        return String(newVal) !== String(oldVal);
      });

      updatedDisabled[tabKey] = !hasChanged;
    });

    setIsDisabledTab(updatedDisabled);
  };

  const [CI_Photo, setCI_Photo] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [professionList, setProfessionList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [yearsOFExperience, setYearsOfExperience] = useState([]);

  const [staffList, setStaffList] = useState([]);

  const filteredOptions = staffList.filter(
    (option) => !candidateData.CI_DocOfficer.includes(option.ED_Id)
  );

  const filteredOptions2 = staffList.filter(
    (option) => !candidateData.CI_CREmp.includes(option.ED_Id)
  );

  const [errors, setErrors] = useState({});

  const inputRefs = {
    CI_Name: useRef(),
    CI_PassportNo: useRef(),
    CI_Profession: useRef(),
    CI_PrimaryEmail: useRef(),
    CI_PrimaryMobile: useRef(),
    CI_Branch: useRef(),
    CI_UserName: useRef(),
  };

  const mandatoryFields = [
    { field: "CI_Name", label: "Candidate Name", tab: 0 },
    { field: "CI_PassportNo", label: "Passport Number", tab: 0 },
    // { field: "CI_PrimaryEmail", label: "Primary Email", type: "email", tab: 0 },
    // { field: "CI_PrimaryMobile", label: "Primary Mobile", tab: 0 },

    { field: "CI_Profession", label: "Profession", tab: 1 },

    { field: "CI_Branch", label: "Branch", tab: 2 },
    { field: "CI_Status", label: "Status", tab: 2 },
    { field: "CI_UserName", label: "User Name", tab: 2 },
  ];

  useEffect(() => {
    const firstErrorField = mandatoryFields.find(
      (field) => errors[field.field]
    );

    if (firstErrorField && inputRefs[firstErrorField.field]?.current) {
      inputRefs[firstErrorField.field].current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      inputRefs[firstErrorField.field].current.focus(); // optional
    }
  }, [errors]);

  useEffect(() => {
    compareTabs(candidateData);
    if (previewUrl !== "") {
      setIsDisabledTab({ ...isDisabledTab, tab0: false });
    }
  }, [candidateData, previewUrl]);

  // Validate the form fields
  const validateForm = () => {
    let formErrors = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[0-9]{20}$/; // 20-digit phone validation

    let firstErrorTab = null;

    for (let { field, label, type, tab } of mandatoryFields) {
      const value = candidateData[field];

      if (type == "email" && !emailRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
        if (firstErrorTab === null) firstErrorTab = tab;
      } else if (!value) {
        formErrors[field] = `${label} is required.`;
        if (firstErrorTab === null) firstErrorTab = tab;
      }

      // Separate date validation (outside the loop)
      if (candidateData.CI_Dateofbirth === "Invalid Date") {
        formErrors["CI_Dateofbirth"] = "Date of Birth format is invalid.";
        if (firstErrorTab === null) firstErrorTab = 0;
      }

      if (candidateData.CI_Last_working_date === "Invalid Date") {
        formErrors["CI_Last_working_date"] =
          "Last Working Date format is invalid.";
        if (firstErrorTab === null) firstErrorTab = 1;
      }
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) {
      if (firstErrorTab !== null) {
        setTabValue(firstErrorTab);
      }

      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });

      return false;
    }

    return true;
  };

  const handlePictureChange = (event) => {
    const file = event.target.files[0];
    const MAX_SIZE_MB = 30;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2); // rounded to 2 decimal places

    if (file.size > MAX_SIZE_BYTES) {
      infoNotify(
        `File size should be less than ${MAX_SIZE_MB} MB. Uploaded file size is ${fileSizeMB} MB`
      );
      return;
    }

    setCI_Photo(event.target.files[0]);
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });

    setCandidateData({
      ...candidateData,
      [name]: value == "" ? null : value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const formData = new FormData();

      if (CI_Photo) {
        formData.append("profilePic", CI_Photo);
        // setCandidateData({...candidateData, IS_UseExisting_Image:false})
        formData.append(`IS_UseExisting_Image`, false);
      } else if (CI_Photo == null && candidateData?.CI_Photo != null) {
        // setCandidateData({...candidateData, IS_UseExisting_Image:true})
        formData.append(`IS_UseExisting_Image`, true);
      } else if (CI_Photo == null && candidateData?.CI_Photo == null) {
        // setCandidateData({...candidateData, IS_UseExisting_Image:true})
        formData.append("profilePic", null);
        formData.append(`IS_UseExisting_Image`, false);
      } else {
        // setCandidateData({...candidateData, IS_UseExisting_Image:true})
        formData.append(`IS_UseExisting_Image`, true);
      }

      Object.entries(candidateData).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });
      formData.delete("CI_UpdatedBy");
      formData.delete("CI_CreatedDate");
      formData.delete("CI_Id");
      formData.delete("CI_Photo");

      formData.append(`CI_UpdatedBy`,sessionStorage?.getItem(`SWA_UserId`) || localStorage?.getItem(`SWA_UserId`));
     

      setIsDisabled(true);
      setLoaderOpen(true);

      axiosupload
        ?.put(`/Candidate/edit/${decryptedId}`, formData)
        .then((res) => {
          successNotify(res?.data?.message);
          setIsDisabled(false);
          setLoaderOpen(false);
          navigate("/Candidates", {
            state: {
              pagination: paginationState,
              filterData: filterData,
              expandedIds: expandedIds,
              open: open,
            },
          });
        })
        .catch((err) => {
          errorNotify('Something went Wrong!');
          setIsDisabled(false);
          setLoaderOpen(false);
        });
    }
  };

  const [loading, setLoading] = useState({
    branches: false,
    yearsOFExperience: false,
    profession: false,
  });

  const getProfession = async () => {
    try {
      setLoading((prev) => ({ ...prev, profession: true }));
      const res = await axiosAPI.get(`/Profession/active/list`);
      setProfessionList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prev) => ({ ...prev, profession: false }));
    }
  };

  const getYearsOfExperience = async () => {
    try {
      const res = await axiosAPI.get(`/YearofExp/active/list`);
      setYearsOfExperience(res?.data?.data || []);
    } catch (err) {
      console.error("Active API failed, retrying without 'active'", err);
      try {
        const resFallback = await axiosAPI.get(`/YearofExp/list`);
        setYearsOfExperience(resFallback?.data?.data || []);
      } catch (fallbackErr) {
        console.error("Fallback API also failed", fallbackErr);
      }
    }
  };

  const getBranches = async () => {
    try {
      setLoading((prev) => ({ ...prev, branches: true }));
      const res = await axiosAPI.get(`/Branch/active/list`);
      setBranchList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prev) => ({ ...prev, branches: false }));
    }
  };

  const getStaff = async () => {
    try {
      setLoading((prev) => ({ ...prev, staffs: true }));
      const res = await axiosAPI.get(`/Employee/reportingstaff`);
      setStaffList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prev) => ({ ...prev, staffs: false }));
    }
  };

  const getData = async () => {
    try {
      const res = await axiosAPI.get(`Candidate/listbyId/${decryptedId}`);

      const dataFromApi = res.data.data;

      setCandidateData(dataFromApi);
      setInitialData(dataFromApi);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getProfession();
    getYearsOfExperience();
    getBranches();
    getStaff();
    getData();
    window.scrollTo(0, 0);
  }, []);

  const [tabValue, setTabValue] = useState(0);

  const [tabs, setTabs] = useState([
    "Personal Information",
    "Professional Details",
    "Other Details",
  ]);

  const handleSubChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
      >
        Edit Candidate
      </Typography>

      {/* Tabs ========================================================================================================================================================================== */}
      <Grid container spacing={2} sx={{ maxWidth: "100vw", overflow: `auto` }}>
        <Grid item>
          <Tabs
            value={tabValue}
            onChange={handleSubChange}
            indicatorColor="error"
            textColor="error"
            variant="scrollable"
            scrollButtons="auto"
            sx={{ fontFamily: "Geist, sans-serif", marginTop: "10px" }}
          >
            {tabs.map((label, index) => (
              <Tab
                key={label}
                label={label}
                sx={{
                  fontFamily: "Geist, sans-serif",
                  background: tabValue == index ? "#006CB8" : "#f5f9ffff",
                  border: "1px solid lightgrey",
                  borderBottom: "4px solid #EAB308",
                  color: tabValue == index ? "white" : "black",
                  fontWeight: tabValue == index ? 600 : 500,
                  fontSize: `14px`,
                  letterSpacing: "1px",
                  minWidth: "150px",
                  minHeight: "60px",
                  marginRight: "5px",
                }}
              />
            ))}
          </Tabs>
        </Grid>
      </Grid>

      {/* Profile Picture + Personal Information*/}
      {tabValue == 0 && (
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          sx={{
            border: "1px solid lightgrey",
            padding: "20px",
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={4}
              xl={3}
              container
              justifyContent="center"
              alignItems="center"
              sx={{ minHeight: 300 }} // Adjust height as needed
            >
              <Grid item>
                <Box sx={{ position: "relative", display: "inline-block" }}>
                  {CI_Photo && previewUrl ? (
                    <>
                      <label htmlFor="picture-upload">
                        <Avatar
                          src={previewUrl}
                          sx={{
                            width: 250,
                            height: 250,
                            border: "2px solid grey",
                            cursor: "pointer",
                          }}
                        />
                      </label>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setCI_Photo(null);
                          setIsDisabledTab({ ...isDisabledTab, tab0: false });
                        }}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          backgroundColor: "#fff",
                          border: "1px solid #ccc",
                          zIndex: 1,
                          "&:hover": {
                            backgroundColor: "#f8d7da",
                          },
                        }}
                      >
                        <DeleteIcon sx={{ color: "#e74c3c", fontSize: 18 }} />
                      </IconButton>
                    </>
                  ) : candidateData?.CI_Photo ? (
                    <>
                      <label htmlFor="picture-upload">
                        <Avatar
                          src={`${process.env.REACT_APP_BASE_URL}/${candidateData?.CI_Photo}`}
                          sx={{
                            width: 250,
                            height: 250,
                            border: "2px solid grey",
                            cursor: "pointer",
                          }}
                        />
                      </label>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setCI_Photo(null);
                          setCandidateData({
                            ...candidateData,
                            CI_Photo: null,
                          });
                        }}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          backgroundColor: "#fff",
                          border: "1px solid #ccc",
                          zIndex: 1,
                          "&:hover": {
                            backgroundColor: "#f8d7da",
                          },
                        }}
                      >
                        <DeleteIcon sx={{ color: "#e74c3c", fontSize: 18 }} />
                      </IconButton>
                    </>
                  ) : (
                    <Avatar
                      sx={{
                        width: 250,
                        height: 250,
                        border: "2px solid grey",
                        cursor: "pointer",
                      }}
                    >
                      <label htmlFor="picture-upload">
                        <IconButton component="span">
                          <CameraAltIcon />
                        </IconButton>
                      </label>
                    </Avatar>
                  )}
                </Box>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="picture-upload"
                  type="file"
                  onChange={handlePictureChange}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={8} lg={8} xl={9} container>
              {/* Full Name */}
              <Grid
                item
                sx={{ padding: "5px" }}
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={4}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Full Name <span style={{ color: "red" }}> * </span>
                </Typography>
                <TextInput
                  label="Full Name"
                  placeholder="Enter Full Name"
                  name="CI_Name"
                  value={candidateData.CI_Name}
                  onChange={handleInputChange}
                  error={!!errors.CI_Name}
                  inputRef={inputRefs.CI_Name}
                />
              </Grid>

              {/* Alias */}
              <Grid
                item
                sx={{ padding: "5px" }}
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={4}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Alias
                </Typography>
                <TextInput
                  label="Alias"
                  placeholder="Enter Alias"
                  name="CI_Alias"
                  value={candidateData.CI_Alias}
                  onChange={handleInputChange}
                />
              </Grid>

              {/* Date of Birth */}
              <Grid
                item
                sx={{ padding: "5px" }}
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={4}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Date of Birth
                </Typography>
                <TextInput
                  label="Date of Birth"
                  placeholder="Date of Birth"
                  name="CI_Dateofbirth"
                  value={candidateData.CI_Dateofbirth}
                  onChange={handleInputChange}
                  type="date"
                  dateRestriction="past"
                />
              </Grid>

              {/* Passport Number */}
              <Grid
                item
                sx={{ padding: "5px" }}
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={4}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Passport Number <span style={{ color: "red" }}> * </span>
                </Typography>
                <TextInput
                  label="Passport Number"
                  placeholder="Enter Passport Number"
                  type="text"
                  name="CI_PassportNo"
                  value={candidateData.CI_PassportNo}
                  onChange={handleInputChange}
                  // // allowOnlyNumbers={true}

                  error={!!errors.CI_PassportNo}
                  inputRef={inputRefs.CI_PassportNo}
                />
              </Grid>

              {/* Email */}
              <Grid
                item
                sx={{ padding: "5px" }}
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={4}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Email 
                </Typography>
                <TextInput
                  label="Email Address"
                  placeholder="Enter Email Address"
                  type="email"
                  name="CI_PrimaryEmail"
                  value={candidateData.CI_PrimaryEmail}
                  onChange={handleInputChange}
                  error={!!errors.CI_PrimaryEmail}
                  inputRef={inputRefs.CI_PrimaryEmail}
                />
              </Grid>

              {/* Secondary Email */}
              <Grid
                item
                sx={{ padding: "5px" }}
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={4}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Secondary Email
                </Typography>
                <TextInput
                  label="Secondary Email Address"
                  placeholder="Enter Secondary Email Address"
                  type="email"
                  name="CI_SecondaryEmail"
                  value={candidateData.CI_SecondaryEmail}
                  onChange={handleInputChange}
                />
              </Grid>

              {/* Mobile Number */}
              <Grid
                item
                sx={{ padding: "5px" }}
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={4}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Mobile
                </Typography>
                <TextInput
                  label="Mobile Number"
                  placeholder="Enter Mobile Number"
                  type="text"
                  name="CI_PrimaryMobile"
                  value={candidateData.CI_PrimaryMobile}
                  error={!!errors.CI_PrimaryMobile}
                  inputRef={inputRefs.CI_PrimaryMobile}
                  onChange={handleInputChange}
                  // allowOnlyNumbers={true}
                  maxLength={20}
                />
              </Grid>

              {/* Emergency Mobile*/}
              <Grid
                item
                sx={{ padding: "5px" }}
                xs={12}
                sm={6}
                md={6}
                lg={6}
                xl={4}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Emergency Mobile
                </Typography>
                <TextInput
                  label="Emergency Mobile Number"
                  placeholder="Enter Emergency Mobile"
                  type="text"
                  name="CI_EmergencyMobile"
                  value={candidateData.CI_EmergencyMobile}
                  onChange={handleInputChange}
                  // allowOnlyNumbers={true}
                  maxLength={15}
                />
              </Grid>

              {/* Address */}
              <Grid
                item
                sx={{ padding: "5px" }}
                xs={12}
                sm={12}
                md={6}
                lg={12}
                xl={4}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Address
                </Typography>
                <TextAreaInput
                  label="Address"
                  placeholder="Enter Address"
                  name="CI_Address"
                  value={candidateData.CI_Address}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Save - Only visible on last tab */}
          <Grid item xs={12} display="flex" justifyContent={"flex-end"} mt={2}>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isDisabledTab.tab0}
            >
              {isDisabled ? "Saving..." : "Save"}
            </Button>
          </Grid>
        </Grid>
      )}

      {/* Professional Details*/}
      {tabValue == 1 && (
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          sx={{
            border: "1px solid lightgrey",
            padding: "20px",
          }}
        >
          <Grid container spacing={2}>
            {/* Medical Profession*/}
            <Grid
              item
              xs={12}
              sm={5}
              md={4}
              lg={4}
              xl={3}
              sx={{
                padding: "5px",
                position: "relative",
                top: { xs: `0px`, sm: `25px` },
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Medical Profession <span style={{ color: "red" }}> * </span>
                <Checkbox
                  checked={Boolean(candidateData.CI_IsMedical)}
                  name="CI_IsMedical"
                  onChange={(e) =>
                    handleInputChange({
                      target: {
                        name: e.target.name,
                        value: e.target.checked ? 1 : 0,
                      },
                    })
                  }
                />
              </Typography>
            </Grid>

            {/* Profession */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={7}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Profession <span style={{ color: "red" }}> * </span>
              </Typography>
              <SelectInput
                value={candidateData.CI_Profession}
                name="CI_Profession"
                onChange={handleInputChange}
                options={professionList?.map((item) => ({
                  value: item?.PI_Id,
                  label: item?.PI_Name,
                }))}
                placeholder="Select Profession"
                error={!!errors.CI_Profession}
                inputRef={inputRefs.CI_Profession}
                loading={loading?.profession}
              />
            </Grid>

            {/* Designation */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Designation
              </Typography>
              <TextInput
                label="Designation"
                placeholder="Enter your Designation"
                name="CI_Designation"
                value={candidateData.CI_Designation}
                onChange={handleInputChange}
              />
            </Grid>

            {/*  Years of Experience  */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Years of Experience
              </Typography>
              <SelectInput
                value={candidateData.CI_YearofExp}
                name="CI_YearofExp"
                onChange={handleInputChange}
                options={yearsOFExperience?.map((item) => ({
                  value: item?.YEL_Id,
                  label: item?.YEL_Name,
                }))}
                placeholder="Select Years of Experience"
                loading={loading?.yearsOFExperience}
              />
            </Grid>

            {/* Registration / License */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Registration / License
              </Typography>
              <TextInput
                label="RegistrationLicense"
                placeholder="Enter your Registration / License Number"
                name="CI_Registration_License"
                value={candidateData.CI_Registration_License}
                onChange={handleInputChange}
              />
            </Grid>

            {/*  Registration / Licence Expiry */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Registration / Licence Expiry
              </Typography>
              <TextInput
                label="Registration / Licence Expiry"
                placeholder="Enter your Registration / Licence Expiry date"
                name="CI_Registration_License_expry"
                value={candidateData.CI_Registration_License_expry}
                onChange={handleInputChange}
              />
            </Grid>

            {/* Department1 */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Department 1
              </Typography>
              <TextInput
                label="Department1"
                placeholder="Enter your Department"
                name="CI_Department1"
                value={candidateData.CI_Department1}
                onChange={handleInputChange}
              />
            </Grid>

            {/* Department2 */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Department 2
              </Typography>
              <TextInput
                label="Department2"
                placeholder="Enter your Department"
                name="CI_Department2"
                value={candidateData.CI_Department2}
                onChange={handleInputChange}
              />
            </Grid>

            {/* Department3 */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Department 3
              </Typography>
              <TextInput
                label="Department3"
                placeholder="Enter your Department"
                name="CI_Department3"
                value={candidateData.CI_Department3}
                onChange={handleInputChange}
              />
            </Grid>

            {/* Last Working day */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Last Working day
              </Typography>
              <TextInput
                label="Last Working day"
                placeholder="Last Working day"
                name="CI_Last_working_date"
                value={candidateData.CI_Last_working_date}
                onChange={handleInputChange}
                type="date"
              />
            </Grid>

            {/* Career Gap */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Career Gap
              </Typography>
              <TextInput
                label="Career Gap"
                placeholder="Enter Career Gap"
                type="tel"
                name="CI_CareerGap"
                value={candidateData.CI_CareerGap}
                onChange={handleInputChange}
                // allowOnlyNumbers={true}
                maxLength={3}
              />
            </Grid>

            {/* Career Gap Details */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Career Gap Details
              </Typography>
              <TextAreaInput
                label="Career Gap Details"
                placeholder="Enter Career Gap Details"
                name="CI_CareerGapDetl"
                value={candidateData.CI_CareerGapDetl}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
          <Grid item sx={{ mt: 2 }} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isDisabledTab.tab1}
            >
              {isDisabled ? "Saving..." : "Save"}
            </Button>
          </Grid>
        </Grid>
      )}

      {/* Other Details */}
      {tabValue == 2 && (
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          sx={{
            border: "1px solid lightgrey",
            padding: "20px",
          }}
        >
          <Grid container spacing={2}>
            {/* CRE */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                CRE
              </Typography>

              <Autocomplete
                multiple
                disableCloseOnSelect
                options={filteredOptions2}
                getOptionLabel={(option) => option.ED_Name}
                value={staffList.filter((opt) =>
                  candidateData.CI_CREmp.includes(opt.ED_Id)
                )}
                onChange={(event, newValue) => {
                  const selectedValues = Array.isArray(newValue)
                    ? newValue
                    : [];
                  setCandidateData({
                    ...candidateData,
                    CI_CREmp: selectedValues.map((option) => option.ED_Id),
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select a Staff"
                    size="small"
                  />
                )}
              />
            </Grid>

            {/* Documentation Officer */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Documentation Officer{" "}
              </Typography>

              <Autocomplete
                multiple
                disableCloseOnSelect
                options={filteredOptions}
                getOptionLabel={(option) => option.ED_Name}
                value={staffList.filter((opt) =>
                  candidateData.CI_DocOfficer.includes(opt.ED_Id)
                )}
                onChange={(event, newValue) => {
                  const selectedValues = Array.isArray(newValue)
                    ? newValue
                    : [];
                  setCandidateData({
                    ...candidateData,
                    CI_DocOfficer: selectedValues.map((option) => option.ED_Id),
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Documentation Officer"
                    size="small"
                  />
                )}
              />
            </Grid>

            {/* Branch */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Branch <span style={{ color: "red" }}> * </span>
              </Typography>
              <SelectInput
                value={candidateData.CI_Branch}
                name="CI_Branch"
                onChange={handleInputChange}
                options={branchList?.map((item) => ({
                  value: item?.BL_Id,
                  label: item?.BL_Name,
                }))}
                placeholder="Select a Branch"
                error={!!errors.CI_Branch}
                inputRef={inputRefs.CI_Branch}
                loading={loading?.branches}
              />
            </Grid>

            {/* Status */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Status <span style={{ color: "red" }}> * </span>
              </Typography>
              <SelectInput
                name="CI_Status"
                value={candidateData?.CI_Status}
                onChange={handleInputChange}
                options={[
                  { value: 1, label: "Active" },
                  { value: 2, label: "Inactive" },
                ]}
                placeholder="Select Status"
              />
            </Grid>

            {/*  User Name */}
            <Grid
              item
              sx={{ padding: "5px" }}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                User Name <span style={{ color: "red" }}> * </span>
              </Typography>
              <TextInput
                label="User Name"
                placeholder="Enter Username"
                name="CI_UserName"
                value={candidateData.CI_UserName}
                onChange={handleInputChange}
                isDisabled={true}
                error={!!errors.CI_UserName}
                inputRef={inputRefs.CI_UserName}
              />
            </Grid>
          </Grid>

          <Grid item sx={{ mt: 2 }} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isDisabledTab.tab2}
            >
              {isDisabled ? "Saving..." : "Save"}
            </Button>
          </Grid>
        </Grid>
      )}

      {/* Buttons */}
      <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={() => {
              navigate("/Candidates", {
                state: {
                  pagination: paginationState,
                  filterData: filterData,
                  expandedIds: expandedIds,
                  open: open,
                },
              });
            }}
          >
            Cancel
          </CommonButton>
        </Grid>
        {/* Back - Visible if not on first tab */}
        {tabValue > 0 && (
          <Grid item>
            <CommonButton
              variant="contained"
              startIcon={<ArrowBackIcon />}
              onClick={() => setTabValue((prev) => prev - 1)}
            >
              Back
            </CommonButton>
          </Grid>
        )}

        {/* Next - Visible if not on last tab */}
        {tabValue < tabs?.length - 1 && (
          <Grid item>
            <CommonButton
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={() => setTabValue((prev) => prev + 1)}
            >
              Next
            </CommonButton>
          </Grid>
        )}

        {/* {tabValue === tabs?.length - 1 && (
          <Grid item>
            <CommonButton
              variant="contained"
              customColor="#007BFF"
              onClick={handleSubmit}
            >
              Save
            </CommonButton>
          </Grid>
        )} */}

        {/* Loader Backdrop */}
        <Backdrop
          open={loaderOpen}
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: "#fff",
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            flexDirection: "column",
          }}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Grid>
    </Paper>
  );
};

export default EditCandidate;
